import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Dictionary } from "@ngrx/entity";
import {friendReactionCountsAdapter, reactionCountsAdapter, ReactionsState} from "./reactions.state";

export const selectReactionsState
    = createFeatureSelector<ReactionsState>("reactions");

export const {
    selectEntities: selectReactionCounts,
    selectAll: selectAllReactionCounts
} =
    reactionCountsAdapter.getSelectors(
        createSelector(selectReactionsState, r => r.reactionCounts)
    );

export const {
    selectEntities: selectFriendReactions,
    selectAll: selectAllFriendReactions
} =
    friendReactionCountsAdapter.getSelectors(
        createSelector(selectReactionsState, r => r.friendReactionCounts)
    );

export const selectFriendReactionsByEntityId = (id: string) =>
    createSelector(
        selectAllFriendReactions,
        reactions =>
            reactions.filter(
                r => r.entityId === id
            ).slice()
    );

